module.exports = __webpack_public_path__ + "img/page21.9c650535.png";